/* global axios */
import ApiClient from './ApiClient';

class LeadSubmissionsAPI extends ApiClient {
  constructor() {
    super('lead_submissions', { accountScoped: true, apiVersion: 'v2' });
  }

  // Filtros: status, lead_source_id, q, page, per_page. Default backend
  // = triage (received/processing/pending_triage/error).
  list(params = {}) {
    return axios.get(this.url, { params });
  }

  convert(id, overrides = {}) {
    return axios.post(`${this.url}/${id}/convert`, { overrides });
  }

  discard(id, reason) {
    return axios.post(`${this.url}/${id}/discard`, { reason });
  }

  reprocess(id) {
    return axios.post(`${this.url}/${id}/reprocess`);
  }
}

export default new LeadSubmissionsAPI();
